module.exports = __webpack_public_path__ + "static/media/46dc8705-e316-4a48-86c0-846b9a9848cf.d98677fb.jpg";